module.exports = __webpack_public_path__ + "static/template_atelier-664fc31325ae1328599e769e6b785ff3.png";